import { ca } from '@cian/analytics';

export function trackShowPhone(gaLabel: string, action: string = 'Open_jk_card') {
  ca('eventSite', {
    action,
    category: 'Phones',
    label: gaLabel,
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackOpenContacts(gaLabel: string) {
  ca('eventSite', {
    action: 'open_contacts',
    category: 'CardJK',
    label: gaLabel,
    name: 'oldevent',
    useLastProducts: true,
  });
}
